import { motion } from 'framer-motion'
import { Heart, Activity, Shield, Zap } from 'lucide-react'

export function Footer() {
  return (
    <footer className="w-full border-t border-border bg-background/80 backdrop-blur-xl mt-auto relative overflow-hidden">
      <motion.div 
        className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-primary/5 opacity-50"
        animate={{ backgroundPosition: ['0% 0%', '100% 0%', '0% 0%'] }}
        transition={{ duration: 15, repeat: Infinity, ease: 'linear' }}
      />
      
      {/* Animated top border line */}
      <motion.div 
        className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-primary/50 to-transparent opacity-50"
        animate={{ scaleX: [0.8, 1.2, 0.8], opacity: [0.3, 0.8, 0.3] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
      />

      <div className="container mx-auto px-4 py-6 relative">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <motion.div 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center gap-2 group cursor-pointer"
          >
            <motion.div 
              className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-300 shadow-[0_0_15px_rgba(var(--primary),0.2)]"
              animate={{ rotate: [0, 5, -5, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
            >
              <Activity className="h-4 w-4 text-primary" />
            </motion.div>
            <div>
              <p className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors">AI Trading Platform</p>
              <p className="text-[10px] text-muted-foreground">Capital.com Integration</p>
            </div>
          </motion.div>

          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <motion.div whileHover={{ y: -2 }} className="flex items-center gap-1.5 hover:text-foreground transition-colors cursor-pointer group">
              <Shield className="h-3.5 w-3.5 group-hover:text-primary transition-colors" />
              <span>Secure</span>
            </motion.div>
            <motion.div whileHover={{ y: -2 }} className="flex items-center gap-1.5 hover:text-foreground transition-colors cursor-pointer group">
              <Zap className="h-3.5 w-3.5 group-hover:text-primary transition-colors" />
              <span>Fast Execution</span>
            </motion.div>
          </div>

          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="flex items-center gap-1.5 text-xs text-muted-foreground"
          >
            <span>Built with</span>
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 1, repeat: Infinity }}
            >
              <Heart className="h-3 w-3 text-red-500 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" />
            </motion.div>
            <span>for intelligent trading</span>
          </motion.div>
        </div>
      </div>
    </footer>
  )
}
